import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
//****** To-do, test loading in the families first asynchronously from check whether to load the url if necessary ******//
var FontConfig = {
  loaded: false
}; //Turn on or off the font loader

function setFontLoaded(loaded) {
  FontConfig.loaded = loaded ? true : false;
}

function checkFontLoaded() {
  return FontConfig.loaded;
} // Define and Load the fonts


var customConfig = {
  families: ['Verizon-NHG-eTX', 'Verizon-NHG-eDS']
};
var fontUri1 = 'https://respframework.verizon.com/verizon-nhg.css';

function finishLoading() {
  return _finishLoading.apply(this, arguments);
}

function _finishLoading() {
  _finishLoading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var WebFont, WebFontConfig;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return import('webfontloader');

          case 3:
            WebFont = _context.sent;
            WebFontConfig = {
              custom: customConfig,
              active: function active() {
                return setFontLoaded(true);
              },
              inactive: function inactive() {
                return console.warn('fonts could not be loaded.');
              }
            };
            WebFont.load && WebFont.load(WebFontConfig);
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            typeof window !== 'undefined' && console.error(_context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _finishLoading.apply(this, arguments);
}

function checkIfLoaded() {
  if (typeof document === 'undefined') return false;
  var links = Array.from(document.head.getElementsByTagName('link'));
  if (!links || !links.length) return false;
  return links.find(function (link) {
    return link.getAttribute('href') === fontUri1;
  });
}

function loadFonts() {
  var loaded = checkIfLoaded();

  if (!loaded) {
    customConfig.urls = [fontUri1];
    finishLoading(customConfig);
  } else setFontLoaded(true);
}

if (checkIfLoaded()) setFontLoaded(true);
if (!checkFontLoaded()) loadFonts();
export var Fonts = {
  VerizonNHGeDS: 'Verizon-NHG-eDS',
  // Display
  VerizonNHGeTX: 'Verizon-NHG-eTX',
  // Text
  checkFontLoaded: checkFontLoaded,
  setFontLoaded: setFontLoaded,
  loadFonts: loadFonts
};